import { Component } from '@angular/core';

@Component({
    selector: 'app-Locked',
    templateUrl: './locked.component.html',
    styleUrls: ['./locked.component.scss']
})
export class LockedComponent {
}
